import React from 'react';

//Components
import { UnlimitedCard } from 'components/unlimitedCard/card';
import PricingInformation from './parts/pricingInformation';
import CoverageSummary from './parts/coveragesSummary';
import TrailersSchedule from './parts/trailersSchedule';
import VehiclesSchedule from './parts/vehicleSchedule';
import DriversSchedule from './parts/driversSchedule';
import Commodities from './parts/commodities';
import ELDCamera from './parts/eldCamera';

//Assets
import Logo from './assets/logo.png';
import TruckImage from './assets/truck.png';

//Helpers
import DateUtils from 'helpers/dateUtils';

const dateUtils = new DateUtils();
const formatCarrier = (carrier) =>
  Array.isArray(carrier) ? carrier.join(', ') : (carrier || 'Cover Whale');

const Review = ({ data }) => {
  return (
    <div className="mt-8 flex items-center justify-center">
      <UnlimitedCard className="w-full max-w-[1000px]">
        <div className="flex justify-between items-center mx-5 mt-5 mb-5">
          <img src={Logo} alt="Logo" className="w-[400px]" />
          <div className="w-full text-center text-black text-sm flex justify-end">
            <div className="w-full flex justify-end">
              <div className="flex flex-col items-end mr-2">
                <strong>Carrier</strong>
                <strong>Submission #</strong>
                <strong>Company Name</strong>
                <strong>Policy Term</strong>
              </div>
              <div className="flex flex-col items-start mr-2">
                <div>{formatCarrier(data?.carrier)}</div>
                <div>{data?.submission_number ?? ''}</div>
                <div>
                  {data?.quote?.insuredInformation?.legalName ?? ''}
                </div>
                <div>
                  {' '}
                  {data?.effective_date &&
                    dateUtils.formatIsoToCommomDate(
                      data?.effective_date
                    )}{' '}
                  -{' '}
                  {data?.effective_date &&
                    dateUtils.formatIsoToCommomDate(
                      dateUtils.addYears(data?.effective_date, 1)
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mt-8 text-center">
          <h1 className="font-bold text-3xl text-black">
            Commercial Trucking data for:
          </h1>
          <div className="mt-2 text-red-500 font-bold">
            {data?.quote?.insuredInformation?.legalName ?? ''}
          </div>
          <div
            style={{ backgroundImage: `url(${TruckImage})` }}
            className="w-[600px] h-[600px] bg-cover bg-no-repeat bg-center mx-auto mt-5"
          />
          <PricingInformation
            financialDetails={data?.financialDetails}
          />
          <CoverageSummary coverages={data?.coverages} />
          <VehiclesSchedule vehicles={data?.quote?.vehicles} />
          <TrailersSchedule trailers={data?.quote?.trailers} />
          <Commodities commodities={data?.quote?.commodities} />
          <ELDCamera operations={data?.quote?.operations} />
          <DriversSchedule drivers={data?.quote?.drivers} />
        </div>
      </UnlimitedCard>
    </div>
  );
};

export default Review;
